import { AccountsRouteSkeleton } from "./AccountsRouteSkeleton.jsx";
import { UsersRouteSkeleton } from "./UsersRouteSkeleton.jsx";
import { EntityTablePageSkeleton } from "./EntityTablePageSkeleton.jsx";
import { DevicesRouteSkeleton } from "./DevicesRouteSkeleton.jsx";
import { TypeCatalogRouteSkeleton } from "./TypeCatalogRouteSkeleton.jsx";
import { ReportBuilderRouteSkeleton } from "./ReportBuilderRouteSkeleton.jsx";
import { DEFAULT_ROUTE_ID } from "../../constants/routes.js";

const ROUTE_SKELETONS = {
  "acc-ov": AccountsRouteSkeleton,
  "user-ov": UsersRouteSkeleton,
  "icp-ov": EntityTablePageSkeleton,
  "dev-ov": DevicesRouteSkeleton,
  "sim-ov": DevicesRouteSkeleton,
  "devtype-ov": TypeCatalogRouteSkeleton,
  "simtype-ov": TypeCatalogRouteSkeleton,
  "rpt-bld": ReportBuilderRouteSkeleton,
};

export function getRouteSkeleton(routeId) {
  return ROUTE_SKELETONS[routeId] ?? ROUTE_SKELETONS[DEFAULT_ROUTE_ID];
}
